module.exports = __webpack_public_path__ + "static/media/iv_failed_reason.eb6341f0.svg";